module.exports = __webpack_public_path__ + "img/income-chart.a1ea8b3c.png";